// removed by extract-text-webpack-plugin
module.exports = {"upload-modal":"upload-documents__upload-modal___3EmPi","upload-content":"upload-documents__upload-content___2Ygms","upload-title":"upload-documents__upload-title___1XNw0","dropzone":"upload-documents__dropzone___3ax4I","active-dropzone":"upload-documents__active-dropzone___3yga9","upload-button":"upload-documents__upload-button___1L0Fm"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/upload-documents.scss
// module id = 1373
// module chunks = 0